<template>
  <div class="container">
    <div>
      <div
        class="mwow-button-filled primary"
        @click="clickexport"
        v-debounce="1000"
      >
        导出
      </div>
      <div
        :class="`mwow-button-filled ${
          multipleSelection.length === 0 ? 'disable' : 'success'
        }`"
        v-debounce="1000"
        style="margin-left: 12px"
        @click="handleOpenChangeTeacher"
      >
        修改课程老师
      </div>
    </div>
    <div class="searchBox">
      <el-form size="mini" ref="form" :model="searchInfo" inline>
        <el-row>
          <el-col :span="8">
            <el-form-item label="学员搜索:" class="my-autocomplete">
              <el-select
                v-model.number="searchInfo.student_id"
                filterable
                clearable
                remote
                placeholder="请选择"
                @change="handleSearch"
                @focus="globalSearch('', 'student')"
                :filter-method="
                  (queryString) => {
                    globalSearch(queryString, 'student');
                  }
                "
              >
                <i class="el-icon-search el-input__icon" slot="prefix"></i>
                <el-option
                  v-for="item in studentName"
                  :key="item.student_id"
                  :label="item.name"
                  :value="Number(item.student_id)"
                >
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 12px">{{
                    item.mobile
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学员状态:">
              <el-radio-group
                v-model="searchInfo.student_status"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="2">在读</el-radio-button>
                <el-radio-button :label="3">历史</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="科目:">
              <el-select
                v-model="searchInfo.subject_id"
                filterable
                clearable
                placeholder="请选择"
                @focus="globalSearch('', 'subject')"
                @change="handleSearch"
                :filter-method="
                  (queryString) => {
                    globalSearch(queryString, 'subject');
                  }
                "
              >
                <el-option
                  v-for="item in subjectsList"
                  :key="item.subject_id"
                  :label="item.subject_title"
                  :value="Number(item.subject_id)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="购买课程:">
              <el-select
                v-model.number="searchInfo.course_id"
                filterable
                clearable
                placeholder="请选择"
                @change="handleSearch"
                @focus="globalSearch('', 'course')"
                :filter-method="
                  (queryString) => {
                    globalSearch(queryString, 'course');
                  }
                "
              >
                <el-option
                  v-for="item in courseName"
                  :key="item.course_id"
                  :label="item.title"
                  :value="Number(item.course_id)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="关联老师:">
              <el-radio-group
                v-model="searchInfo.relation_teacher_state"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button label="already_relation">
                  已关联
                </el-radio-button>
                <el-radio-button label="not_relation">未关联</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="停课状态:">
              <el-select
                @change="handleSearch"
                clearable
                v-model="searchInfo.stop_status"
                placeholder="请选择"
                class="drawer_onlychoose"
                multiple
              >
                <el-option
                  v-for="item in stopStatusList"
                  :key="item.value"
                  :label="item.value"
                  :value="Number(item.key)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="showFormSearch">
          <el-col :span="8">
            <el-form-item label="结课状态:">
              <el-radio-group
                v-model="searchInfo.completion_status"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">未结课</el-radio-button>
                <el-radio-button :label="2">已结课</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="剩余课时:">
              <div class="inputBox">
                <el-input
                  v-model="searchInfo.usable_number_start"
                  placeholder="最小值"
                  @change="
                    (v) => {
                      if (Number(v) < 0) {
                        searchInfo.usable_number_start = '0';
                      }
                      handleSearch();
                    }
                  "
                ></el-input>
                <span>至</span>
                <el-input
                  v-model="searchInfo.usable_number_end"
                  placeholder="最大值"
                  @change="
                    (v) => {
                      if (Number(v) > 99999999.99) {
                        searchInfo.usable_number_end = '99999999.99';
                      }
                      handleSearch();
                    }
                  "
                >
                </el-input>
                <span
                  class="el-icon-error clear-icon"
                  v-if="
                    searchInfo.usable_number_start &&
                    searchInfo.usable_number_end
                  "
                  @click="
                    () => {
                      searchInfo.usable_number_start = '';
                      searchInfo.usable_number_end = '';
                      handleSearch();
                    }
                  "
                ></span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="超上课时:" prop="class_student_full">
              <el-radio-group
                v-model="searchInfo.is_exceed"
                @change="handleSearch"
              >
                <el-radio-button :label="0">全部</el-radio-button>
                <el-radio-button :label="1">超上</el-radio-button>
                <el-radio-button :label="2">正常</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="showFormSearch">
          <el-col :span="8">
            <el-form-item label="到期状态:">
              <el-select
                @change="handleSearch"
                clearable
                v-model="searchInfo.expire_status"
                placeholder="请选择"
                class="drawer_onlychoose"
                multiple
              >
                <el-option label="无" :value="0"></el-option>
                <el-option label="已到期" :value="1"></el-option>
                <el-option label="未到期" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课程顾问:">
              <common-staff-pull-down
                :originId.sync="searchInfo.follow_staff_id"
                :defaultSelected.sync="searchInfo.follow_staff_list"
                :jobIds="[3]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="教务老师:">
              <common-staff-pull-down
                :originId.sync="searchInfo.teacher_id"
                :defaultSelected.sync="searchInfo.teacher_list"
                :jobIds="[2]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="showFormSearch">
          <el-col :span="8">
            <el-form-item label="课程老师:">
              <common-staff-pull-down
                :originId.sync="searchInfo.relation_teacher_id"
                :defaultSelected.sync="searchInfo.relation_teacher_list"
                :jobIds="[1]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="time-line-switch">
          <div class="p4" @click="showFormSearch = !showFormSearch">
            {{ showFormSearch ? "收起" : "展开" }}
            <span
              :class="
                showFormSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
              "
            ></span>
          </div>
        </div>
        <div class="time-line-switch resetting">
          <div class="p4" @click="resetSearch">
            重置
            <span class="el-icon-refresh-right"></span>
          </div>
        </div>
      </el-form>
    </div>
    <div class="table-total">
      未耗课时数{{ Number(courseCount.usable_number) }}，未耗课金额{{
        Number(courseCount.usable_amount)
      }}元，停课课程{{ Number(courseCount.stop_course_count) }}个，到期课程{{
        Number(courseCount.expire_count)
      }}个，超上课时数{{
        Number(courseCount.exceed_number)
      }}个，未关联课程老师{{ Number(courseCount.not_relation_count) }}个
    </div>
    <div>
      <el-table
        size="mini"
        v-horizontal-scroll
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
        stripe
        :data="tableData"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="52"
          align="center"
        ></el-table-column>
        <el-table-column label="学员姓名" prop="student_name" width="120">
          <template slot-scope="scope">
            <div
              v-if="scope.row.student"
              class="mwow-green studentName"
              @click="goStudentDetail(scope.row.student_id.toString())"
            >
              {{ scope.row.student.name || "-" }}
              <span
                v-if="scope.row.student.is_del === 1"
                class="mwow-tag del-filled large"
              >
                已删除</span
              >
              <span
                v-if="scope.row.student.status === 2"
                class="mwow-tag success-filled large"
              >
                在读</span
              >
              <span
                v-if="scope.row.student.status === 3"
                class="mwow-tag danger-filled large"
              >
                历史</span
              >
            </div>
            <div v-else></div>
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="120" prop="mobile">
          <template slot-scope="scope">
            {{ "+" + scope.row.student.area_code }}
            {{ scope.row.student ? scope.row.student.mobile || "-" : "-" }}
          </template>
        </el-table-column>
        <el-table-column label="科目" prop="subject.subject_title">
          <template slot-scope="scope">
            {{ scope.row.subject ? scope.row.subject.subject_title : "-" }}
          </template>
        </el-table-column>
        <el-table-column label="购买课程" prop="title" min-width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.course && scope.row.course.title">
              {{ scope.row.course.title }}
              <span class="mwow-red" v-show="scope.row.stop_status === 2">
                停课中</span
              >
              <span class="mwow-red" v-show="scope.row.stop_end_time">
                ({{ scope.row.stop_end_time }} 复课)</span
              >
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="结课状态" width="70">
          <template slot-scope="scope">
            {{ scope.row.completionstatusname }}
          </template>
        </el-table-column>
        <el-table-column label="购课金额" prop="receivable_amount">
          <template slot-scope="scope">
            {{ scope.row.receivable_amount || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          label="课消金额"
          prop="consume_amount"
        ></el-table-column>
        <el-table-column width="100" label="剩余金额" prop="usable_amount">
        </el-table-column>
        <el-table-column label="购买课时" prop="total_buy_number">
        </el-table-column>
        <el-table-column label="赠送课时" prop="total_give_number">
        </el-table-column>
        <el-table-column label="转退课时" prop="refund_number">
        </el-table-column>
        <el-table-column label="耗课数" prop="consume_number">
        </el-table-column>
        <el-table-column label="剩余课时" prop="usable_number" width="150">
          <template slot="header">
            <span>剩余课时</span>
            <span style="display: inline-block">
              <el-popover
                placement="top"
                width="190"
                popper-class="followuppopover"
                trigger="hover"
              >
                <p class="tipck">
                  学员在剩余课时不足的情况下继续上课，多上的课时会标记为超上，请及时联系学员并续费补扣。
                </p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </span>
          </template>
          <template slot-scope="scope">
            <div class="selfheader">
              <span style="margin-right: 5px">{{
                scope.row.usable_number
              }}</span>
              <div class="selfheader" v-if="scope.row.exceed_number != 0">
                <span class="mwow-red">
                  ( 超上{{ scope.row.exceed_number }}课时 )</span
                >
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="到期日期" prop="expire_time" width="125">
          <template slot-scope="scope"
            >{{ scope.row.expire_time || "-"
            }}<span class="mwow-red" v-show="scope.row.expire_status === 1">
              已到期</span
            ></template
          >
        </el-table-column>
        <el-table-column label="课程顾问" width="120">
          <template slot-scope="scope">
            {{
              scope.row.follow_staff.name == ""
                ? "-"
                : scope.row.follow_staff.name
            }}
          </template>
        </el-table-column>
        <el-table-column label="教务老师" width="120">
          <template slot-scope="scope">
            {{ scope.row.teacher.name == "" ? "-" : scope.row.teacher.name }}
          </template>
        </el-table-column>
        <el-table-column width="120">
          <template slot="header">
            <span>课程老师</span>
            <span style="display: inline-block">
              <el-popover
                placement="top"
                width="190"
                popper-class="followuppopover"
                trigger="hover"
              >
                <p class="tipck">
                  教师学员关联数据，可点击关联详情跳转预览详细过程；
                </p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </span>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.relation_teacher_list">
              {{
                scope.row.relation_teacher_list
                  .map((item) => {
                    return item.name;
                  })
                  .join("、")
              }}
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="280">
          <template slot-scope="scope">
            <div class="operationBox">
              <div
                class="mwow-button success"
                @click="operation(scope.row, 'stop')"
                v-if="
                  scope.row.completion_status == 1 && scope.row.stop_status == 1
                "
              >
                停课
              </div>
              <div
                class="mwow-button success"
                @click="operation(scope.row, 'resume')"
                v-if="
                  scope.row.completion_status == 1 && scope.row.stop_status == 2
                "
              >
                复课
              </div>
              <div
                class="mwow-button success"
                @click="operation(scope.row, 'renew')"
                v-if="orderCourseSwitch"
              >
                续费
              </div>
              <div
                class="mwow-button info"
                @click="operation(scope.row, 'end')"
                v-if="scope.row.completion_status == 1"
              >
                结课
              </div>
              <div
                style="display: inline-block"
                v-if="scope.row.completion_status == 1"
              >
                <div
                  class="mwow-button success"
                  @click="handleClickTeacher(scope.row)"
                >
                  课程老师
                </div>
              </div>
              <div
                style="display: inline-block"
                v-if="scope.row.relation_teacher_list"
              >
                <teacher-and-student-detail
                  :student-id="scope.row.student.student_id"
                  :course-id="scope.row.course.course_id"
                  :originData="detailInfo"
                  from="purchase"
                >
                  <div
                    class="mwow-button success"
                    @click="handleClickDetail(scope.row)"
                  >
                    关联详情
                  </div>
                </teacher-and-student-detail>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
    <!-- 停课 -->
    <el-dialog
      title="停课"
      :visible.sync="suspensionBtn"
      width="30%"
      :before-close="handleClose"
    >
      <div class="explain">
        停课后，学员【{{
          choosetabeldata.student.name
        }}】将不能点名签到，同时不会再收到开课提醒、班级课时作业；
        课程的有效期将被取消；
        <br />
        如果设置了复课日期，到期后将自动恢复上课，可以进行点名签到，开课提醒、班级课时作业提醒都可以收到。
      </div>
      <el-form
        size="mini"
        :inline="true"
        :model="suspensionformIn"
        :rules="rules"
        ref="suspension"
      >
        <div class="suspensionBox">
          <el-form-item
            label="停课时间:"
            label-width="80px"
            prop="start_time_suspen"
          >
            <el-date-picker
              v-model="suspensionformIn.start_time_suspen"
              type="date"
              placeholder="请选择时间"
              value-format="timestamp"
              :picker-options="expireTimeOption"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="suspensionBox">
          <el-form-item label="复课时间:" label-width="80px">
            <el-date-picker
              v-model="suspensionformIn.end_time_suspen"
              type="date"
              placeholder="请选择时间"
              value-format="timestamp"
              :picker-options="expireTimeOption"
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="mwow-button-filled mini" @click="suspensionclickClose">
          取 消
        </div>
        <div
          class="mwow-button-filled mini success"
          @click="suspensionclickComfir"
        >
          停 课
        </div>
      </span>
    </el-dialog>
    <!-- 停课end -->
    <!-- 复课 -->
    <el-dialog title="复课" :visible.sync="resumeBtn" width="30%">
      <div class="explain color">复课后，请重新设置课程最终到期时间</div>
      <el-form
        size="mini"
        :inline="true"
        :model="resumeformIn"
        :rules="rules"
        ref="suspension"
      >
        <div class="suspensionBox">
          <el-form-item label="停课时间:" label-width="80px">
            <el-input
              v-model="resumeformIn.start_time_suspen_tran"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </div>
        <div class="suspensionBox">
          <el-form-item
            label="复课时间:"
            label-width="80px"
            prop="end_time_suspen"
          >
            <el-date-picker
              v-model="resumeformIn.end_time_suspen"
              type="date"
              placeholder="请选择时间"
              :picker-options="expireTimeOption"
              value-format="timestamp"
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="mwow-button info" @click="resumeclickClose">取 消</div>
        <div class="mwow-button-filled success" @click="resumeclickComfir">
          复 课
        </div>
      </span>
    </el-dialog>
    <!-- 复课end -->

    <teacher-dialog
      :visible.sync="teacherDialogVisible"
      :originData="currentItemInfo"
      @change="handleTeacherChange"
    >
    </teacher-dialog>
    <!-- 批量改动教师 -->
    <change-teacher-dialog
      :visible.sync="changeTeacherDialogVisible"
      :origin-data="multipleSelection"
      @change="handleRefresh"
    ></change-teacher-dialog>
  </div>
</template>
<script>
import {
  courseListData,
  getcourseFinish,
  getcourseFreeze,
  getcourseUnfreeze,
  getfreezerecord,
  exportStudentcourse,
  studentCourseCountApi,
} from "@/api/purchase";
import teacherAndStudentDetail from "../../teacherManage/teacherAndStudent/teacherAndStudentDetail.vue";
import { exportLoop } from "@/utils/export";
import { dateFormat } from "@/utils/timeFormat";
import { PageModule } from "@/store/module/page";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import {
  staffList,
  getSelectClassList,
  getSelectCourseList,
  searchStudent,
} from "@/api/globalSearch";
import { subjectList } from "@/api/subject";
import teacherDialog from "./teacherDialog.vue";
import { UserModule } from "@/store/module/user";
import changeTeacherDialog from "./changeTeacherDialog.vue";

export default {
  props: ["visible"],
  components: {
    teacherAndStudentDetail,
    commonStaffPullDown,
    teacherDialog,
    changeTeacherDialog,
  },
  data() {
    return {
      searTypeenter: "", //判断输入时名字还是数字
      searchInfo: {
        is_exceed: 0,
        stop_status: [],
        completion_status: -1,
        student_status: -1,
        expire_status: [],
        usable_number_start: "",
        usable_number_end: "",
        follow_staff_id: "",
        follow_staff_list: [],
        teacher_id: "",
        teacher_list: [],
        relation_teacher_id: "",
        relation_teacher_list: [],
        relation_teacher_state: -1,
      }, //搜索数据
      tableData: [], //列表数据
      mobileRelationList: [], //手机关系人数据
      guardianList: [], //弹出监护人数据
      sourceTypeList: [], //弹出来源列表数据
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      page: 1,
      subject: "", //科目
      staffName: "", //员工搜索名字
      teacherName: "", //教师搜索名字
      teacherName2: "", //教务老师搜索名字
      courseName: "", //课程名字
      studentName: "", //学员姓名
      className: "",
      // expireTime : "", //到期时间
      remainingtime: "", //剩余时间
      suspensionBtn: false, //停课弹框
      resumeBtn: false, //复课弹框
      start_time_suspen: "", //停课时间
      end_time_suspen: "", //复课时间
      suspensionformIn: {}, //停课表单
      resumeformIn: {}, //复课表单
      subjectsList: [],
      showFormSearch: false,
      choosetabeldata: {
        student: {},
        course: {},
      }, //选择学员id
      stop_id: 0, //停课id
      stopStatusList: [
        { value: "正常", key: 1 },
        { value: "停课中", key: 2 },
        { value: "待复课", key: 3 },
      ],
      rules: {
        start_time_suspen: [
          { required: true, message: "请选择停课时间", trigger: "blur" },
        ],
        end_time_suspen: [
          { required: true, message: "请选择复课时间", trigger: "blur" },
        ],
      },
      courseCount: {
        usable_number: 0,
        usable_amount: 0,
        stop_course_count: 0,
        expire_count: 0,
        exceed_number: 0,
        not_relation_count: 0,
      },
      // 当前项的信息
      currentItemInfo: {
        teacherCheckedData: [], // 课程老师
        student_id: "",
        course_id: "",
        student_name: "", // 变更时的学员姓名
        course_title: "", // 变更时的课程名称
      },
      detailInfo: {},
      teacherDialogVisible: false,
      expireTimeOption: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
        },
      },
      changeTeacherDialogVisible: false,
      multipleSelection: [],
    };
  },
  computed: {
    orderCourseSwitch() {
      return UserModule.userInfo.order_course_switch === 1;
    },
  },

  created() {
    const _t = this;
    if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      const params = this.$route.params;
      if (params.stop_status) {
        this.searchInfo.stop_status = [Number(params.stop_status)];
      }
    }
    const pageData = PageModule.pageInfo.purchase;
    if (pageData.page) {
      _t.page = pageData.page;
    }
    if (pageData.page_size) {
      _t.pageSize = pageData.page_size;
    }
    if (pageData.search_info) {
      _t.searchInfo = pageData.search_info;
    }
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        _t.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      _t.init();
    }
  },
  methods: {
    init() {
      const _t = this;
      _t.getList({
        page: _t.page,
        page_size: _t.pageSize,
      });
      if (this.searchInfo.student_id) {
        this.globalSearch("", "student");
      }
      if (this.searchInfo.subject_id) {
        this.globalSearch("", "subject");
      }
      if (this.searchInfo.course_id) {
        this.globalSearch("", "course");
      }
    },
    handleOpenChangeTeacher() {
      if (this.multipleSelection.length === 0) {
        return false;
      }
      this.changeTeacherDialogVisible = true;
    },
    handleSelectionChange(arr) {
      this.multipleSelection = arr;
    },
    handleClickTeacher(row) {
      this.currentItemInfo = {
        teacherCheckedData: row.relation_teacher_list || [],
        student_id: row.student_id,
        course_id: row.course_id,
        student_name: row.student.name,
        course_title: row.course.title,
      };
      this.teacherDialogVisible = true;
    },
    handleTeacherChange() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },

    handleClickDetail(row) {
      this.detailInfo = {
        student: row.student.name,
        course: row.course.title,
      };
    },
    // 去到学员详情
    goStudentDetail(sid) {
      this.cachePageInfo();
      this.$router.push({
        name: "studyDetails",
        query: {
          id: sid,
        },
      });
    },
    resetSearch() {
      this.searchInfo = {
        is_exceed: 0,
        stop_status: [],
        completion_status: -1,
        student_status: -1,
        expire_status: [],
        usable_number_start: "",
        usable_number_end: "",
        follow_staff_id: "",
        follow_staff_list: [],
        teacher_id: "",
        teacher_list: [],
        relation_teacher_id: "",
        relation_teacher_list: [],
      };
      this.page = 1;
      this.pageSize = 10;
      this.getList(
        {
          page: this.page,
          page_size: this.pageSize,
        },
        () => {}
      );
    },
    checkNumber(theObj) {
      const regPos = /^\d+(\.\d+)?$/; //非负浮点数
      const regNeg =
        /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
      if (regPos.test(theObj) || regNeg.test(theObj)) {
        return true;
      } else {
        return false;
      }
    },
    lookDetails(e) {
      const _t = this;
      _t.$router.push({ name: "studyDetails", query: { id: e.student_id } });
    },
    // 导出开始
    clickexport() {
      const _t = this;
      const data = {};
      if (_t.searchInfo.student_id) {
        data.student_id = _t.searchInfo.student_id;
      }
      if (_t.searchInfo.course_id) {
        data.course_id = _t.searchInfo.course_id;
      }
      if (_t.searchInfo.teacher_id) {
        data.teacher_id = _t.searchInfo.teacher_id;
      }
      if (_t.searchInfo.stop_status.length > 0) {
        data.stop_status = _t.searchInfo.stop_status;
      }
      if (_t.searchInfo.completion_status > 0) {
        data.completion_status = _t.searchInfo.completion_status;
      }
      if (_t.searchInfo.follow_staff_id) {
        data.follow_staff_id = _t.searchInfo.follow_staff_id;
      }
      if (_t.searchInfo.usable_number_start) {
        data.usable_number_start = _t.searchInfo.usable_number_start + "";
      }
      if (_t.searchInfo.usable_number_end) {
        data.usable_number_end = _t.searchInfo.usable_number_end + "";
      }
      if (_t.searchInfo.is_exceed) {
        data.is_exceed = _t.searchInfo.is_exceed;
      }
      if (_t.searchInfo.subject_id) {
        data.subject_id = _t.searchInfo.subject_id;
      }
      if (_t.searchInfo.expire_status.length > 0) {
        data.expire_status = _t.searchInfo.expire_status;
      }
      if (_t.searchInfo.student_status > 0) {
        data.student_status = _t.searchInfo.student_status;
      }
      if (_t.searchInfo.relation_teacher_id) {
        data.relation_teacher_id = _t.searchInfo.relation_teacher_id;
      }
      if (_t.searchInfo.relation_teacher_state !== -1) {
        data.relation_teacher_state = _t.searchInfo.relation_teacher_state;
      }
      exportStudentcourse(data).then((res) => {
        if (res.error_code == 0) {
          exportLoop(res.data.task_id);
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    // 导出结束
    choosestatus() {
      const _t = this;
    },
    // 学员搜索~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~end
    // 通用搜索框
    getSelectrList(e) {
      const _t = this;
      _t.globalSearch("", e);
    },
    getglobalsearchdata(data, type) {
      if (type == "staff") {
        data.job_ids = [3];
        return staffList(data);
      } else if (type == "teacher") {
        data.job_ids = [1];
        return staffList(data);
      } else if (type == "class") {
        return getSelectClassList(data);
      } else if (type == "course") {
        return getSelectCourseList(data);
      } else if (type == "student") {
        return searchStudent(data);
      } else if (type == "teacher2") {
        data.job_ids = [2];
        return staffList(data);
      } else if (type == "subject") {
        return subjectList({
          page: data.page,
          page_size: data.page_size,
          title: data.title,
        });
      }
    },
    async globalSearch(queryString, type) {
      const _t = this;
      let data = {
        page: 1,
        page_size: 100,
      };
      let restaurants = {};
      if (queryString) {
        data = {
          page: 1,
          page_size: 10,
        };
        if (type == "class") {
          data.name = queryString;
        } else if (type == "course") {
          data.title = queryString;
        } else if (type == "student") {
          data.key_word = queryString;
        } else if (type == "subject") {
          data.title = queryString;
        } else {
          data.key_word = queryString;
        }
      }
      restaurants = await _t.getglobalsearchdata(data, type);
      const list = restaurants.data.list;
      if (type == "staff") {
        _t.staffName = list;
      } else if (type == "teacher") {
        _t.teacherName = list;
      } else if (type == "class") {
        _t.className = list;
      } else if (type == "course") {
        _t.courseName = list;
      } else if (type == "student") {
        _t.studentName = list;
      } else if (type == "subject") {
        _t.subjectsList = list;
      } else if (type == "teacher2") {
        _t.teacherName2 = list;
      }
    },
    // 通用搜索框结束
    getList(data, cb) {
      const _t = this;
      if (_t.searchInfo.student_id) {
        data.student_id = _t.searchInfo.student_id;
      }
      if (_t.searchInfo.course_id) {
        data.course_id = _t.searchInfo.course_id;
      }
      if (_t.searchInfo.teacher_id) {
        data.teacher_id = _t.searchInfo.teacher_id;
      }
      if (_t.searchInfo.stop_status.length > 0) {
        data.stop_status = _t.searchInfo.stop_status;
      }
      if (_t.searchInfo.completion_status > 0) {
        data.completion_status = _t.searchInfo.completion_status;
      }
      if (_t.searchInfo.follow_staff_id) {
        data.follow_staff_id = _t.searchInfo.follow_staff_id;
      }
      data.usable_number_start = "0";
      data.usable_number_end = "99999999.99";
      if (_t.searchInfo.usable_number_start) {
        data.usable_number_start = _t.searchInfo.usable_number_start + "";
      }
      if (_t.searchInfo.usable_number_end) {
        data.usable_number_end = _t.searchInfo.usable_number_end + "";
      }
      if (_t.searchInfo.is_exceed) {
        data.is_exceed = _t.searchInfo.is_exceed;
      }
      if (_t.searchInfo.subject_id) {
        data.subject_id = _t.searchInfo.subject_id;
      }
      if (_t.searchInfo.expire_status.length > 0) {
        data.expire_status = _t.searchInfo.expire_status;
      }
      if (_t.searchInfo.student_status > 0) {
        data.student_status = _t.searchInfo.student_status;
      }
      if (_t.searchInfo.relation_teacher_id) {
        data.relation_teacher_id = _t.searchInfo.relation_teacher_id;
      }
      if (_t.searchInfo.relation_teacher_state !== -1) {
        data.relation_teacher_state = _t.searchInfo.relation_teacher_state;
      }
      courseListData(data).then((res) => {
        if (res.error_code == 0) {
          if (res.data.list != null) {
            const setNumber = [
              "consume_amount",
              "consume_number",
              "exceed_number",
              "refund_number",
              "total_buy_number",
              "total_give_number",
              "usable_amount",
              "usable_number",
            ];
            res.data.list.map((item) => {
              item.completionstatusname =
                item.completion_status == 1 ? "未结课" : "已结课";
              item.expire_time =
                item.expire_time != ""
                  ? dateFormat("YYYY-mm-dd", item.expire_time * 1000)
                  : "-";
              item.stop_end_time =
                item.stop_end_time != ""
                  ? dateFormat("YYYY-mm-dd", item.stop_end_time * 1000)
                  : "";
              setNumber.map((i) => {
                if (item[i]) {
                  item[i] = Number(item[i]);
                }
              });
            });
          }
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
          if (cb) {
            cb();
          }
        }
      });
      studentCourseCountApi(data).then((res) => {
        this.courseCount = res.data;
      });
    },
    //获取表单列表
    getFormList(cb, type) {
      const _t = this;
      cb().then((res) => {
        if (res.error_code == 0) {
          _t[type] = res.data;
        }
      });
    },
    cachePageInfo() {
      PageModule.SET_PAGE_INFO({
        name: "purchase",
        key: "page",
        value: this.page,
      });
      PageModule.SET_PAGE_INFO({
        name: "purchase",
        key: "page_size",
        value: this.pageSize,
      });
      PageModule.SET_PAGE_INFO({
        name: "purchase",
        key: "search_info",
        value: this.searchInfo,
      });
    },
    handlePagerChange(e) {
      this.cachePageInfo();
      this.getList(
        {
          page: e,
          page_size: this.pageSize,
        },
        () => {}
      );
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.cachePageInfo();
      this.getList(
        {
          page: 1,
          page_size: e,
        },
        () => {}
      );
    },
    handleSearch() {
      const _t = this;
      this.getList(
        {
          page: 1,
          page_size: _t.pageSize,
        },
        () => {}
      );
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    suspensionclickClose() {
      const _t = this;
      _t.suspensionBtn = false;
      delete _t.suspensionformIn.end_time_suspen;
      delete _t.suspensionformIn.start_time_suspen;
    },
    handleClose(done) {
      const _t = this;
      done();
      delete _t.suspensionformIn.end_time_suspen;
      delete _t.suspensionformIn.start_time_suspen;
    },
    resumeclickClose() {
      const _t = this;
      _t.resumeBtn = false;
      _t.stop_id = 0;
    },
    resumeclickComfir() {
      const _t = this;
      const data = {};
      data.stop_id = _t.stop_id;
      if (_t.resumeformIn.end_time_suspen) {
        data.end_time = _t.resumeformIn.end_time_suspen / 1000;
      }
      _t.$refs["suspension"].validate((valid) => {
        if (valid) {
          getcourseUnfreeze(data).then((res) => {
            if (res.error_code == 0) {
              _t.$message({
                type: "success",
                message: "复课成功!",
              });
              this.getList(
                {
                  page: _t.page,
                  page_size: _t.pageSize,
                },
                () => {}
              );
              _t.resumeBtn = false;
              _t.stop_id = 0;
            } else {
              _t.$message({
                type: "error",
                message: "复课失败!" + res.message,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    suspensionclickComfir() {
      const _t = this;
      const data = {};
      data.account_id = _t.choosetabeldata.account_id;
      if (_t.suspensionformIn.start_time_suspen) {
        data.start_time = _t.suspensionformIn.start_time_suspen / 1000;
      }
      if (_t.suspensionformIn.end_time_suspen) {
        data.end_time = _t.suspensionformIn.end_time_suspen / 1000;
      }
      _t.$refs["suspension"].validate((valid) => {
        if (valid) {
          getcourseFreeze(data).then((res) => {
            if (res.error_code == 0) {
              _t.$message({
                type: "success",
                message: "停课成功!",
              });
              _t.getList(
                {
                  page: _t.page,
                  page_size: _t.pageSize,
                },
                () => {}
              );
              _t.suspensionBtn = false;
              delete _t.suspensionformIn.end_time_suspen;
              delete _t.suspensionformIn.start_time_suspen;
            } else {
              _t.$message({
                type: "error",
                message: "停课失败!" + res.message,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    operation(e, type) {
      this.cachePageInfo();
      const _t = this;
      if (type == "end") {
        _t.$confirm(
          "结课后，课程下的所有剩余课时都将被清零，此操作无法恢复。",
          `结课 - ${e.course.title}`,
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            type: "warning",
          }
        )
          .then(() => {
            getcourseFinish({ account_id: e.account_id }).then((res) => {
              if (res.error_code == 0) {
                _t.$message({
                  type: "success",
                  message: "结课成功!",
                });
                _t.getList(
                  {
                    page: _t.page,
                    page_size: _t.pageSize,
                  },
                  () => {}
                );
              } else if (res.error_code === 21015005) {
                setTimeout(() => {
                  _t.$confirm(`${res.message}`, `结课 - ${e.course.title}`, {
                    confirmButtonText: "确定",
                    confirmButtonClass: "mwow-button-filled success mini",
                    cancelButtonText: "取消",
                    cancelButtonClass: "mwow-button-filled mini",
                    type: "warning",
                  })
                    .then(() => {
                      getcourseFinish({
                        account_id: e.account_id,
                        force: 1,
                      }).then((res) => {
                        if (res.error_code == 0) {
                          _t.$message({
                            type: "success",
                            message: "结课成功!",
                          });
                          _t.getList(
                            {
                              page: _t.page,
                              page_size: _t.pageSize,
                            },
                            () => {}
                          );
                        }
                      });
                    })
                    .catch(() => {});
                }, 100);
              }
            });
          })
          .catch(() => {});
      } else if (type == "stop") {
        _t.suspensionBtn = true;
        _t.choosetabeldata = e;
      } else if (type == "resume") {
        _t.resumeBtn = true;
        _t.choosetabeldata = e;
        getfreezerecord({ account_id: _t.choosetabeldata.account_id }).then(
          (res) => {
            if (res.error_code == 0) {
              if (res.data.list.length > 0) {
                res.data.list.map((a) => {
                  if (a.status == 1 || a.status == 2) {
                    _t.stop_id = a.stop_id;
                    _t.resumeformIn.start_time_suspen = a.start_time;
                    _t.resumeformIn.start_time_suspen_tran = dateFormat(
                      "YYYY-mm-dd",
                      new Date(Number(a.start_time + "000"))
                    );
                    if (a.end_time) {
                      _t.$set(
                        _t.resumeformIn,
                        "end_time_suspen",
                        Number(a.end_time + "000")
                      );
                    }
                  }
                });
              }
              _t.getList(
                {
                  page: _t.page,
                  page_size: _t.pageSize,
                },
                () => {}
              );
            }
          }
        );
      } else if (type == "renew") {
        if (e.course.delete_time > 0) {
          _t.$message({
            type: "error",
            message: "课程已删除",
          });
          return;
        }
        if (e.course.sales_status == 2) {
          _t.$message({
            type: "error",
            message: "课程已关闭购买",
          });
          return;
        }
        _t.$router.push({
          name: "buyCourseConfirm",
          query: { id: e.student_id, course_id: e.course_id },
        });
      }
    },
    // 课程老师
    handleUnassociateTeacher() {
      this.searchInfo.relation_teacher_state = "not_relation";
      this.handleSearch();
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0 12px 12px 12px;
}
.table-total {
  margin-bottom: 12px;
  height: 28px;
  background: #fff7e9;
  border-radius: 4px;
  font-size: 12px;
  line-height: 28px;
  color: #5c5d5e;
  padding: 0 10px;
  .red {
    color: #f56c6c;
    cursor: pointer;
  }
}
/deep/ .searchBox {
  margin-top: 12px;
  .inputBox {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    line-height: 30px;
    height: 30px !important;
    .el-input {
      width: 165px;
    }
    .el-input__inner {
      border: none !important;
    }
    span {
      margin: 0 10px 0 0;
    }
  }
}
.my-autocomplete {
  /deep/ li {
    line-height: normal;
    padding: 7px;
    height: auto;
    .autocompletename {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .autocompleteaddr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .autocompleteaddr {
      color: #ddd;
    }
  }
}
.el-form .el-form-item__label {
  text-align: left !important;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 18px !important;
  margin-right: 80px !important;
  line-height: 30px !important;
}
.operationBox {
  .mwow-button {
    margin: 0;
    margin-right: 10px;
  }
}
.explain {
  font-size: 12px;
  color: #5c5d5e;
  line-height: 18px;
}
.explain.color {
  color: #07d1aa;
}
.suspensionBox:nth-of-type(1) {
  margin-top: 20px;
}
.suspensionBox {
  .el-form-item {
    margin-bottom: 18px !important;
  }
  .el-input {
    width: 220px !important;
  }
}
.green {
  color: #07d1aa;
}
.el-range-editor--small.el-input__inner {
  height: 30px !important;
}
.selfheader {
  display: flex;
  align-items: center;
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
.studentName {
  cursor: pointer;
}
/deep/ .el-form {
  .el-form-item {
    width: 100%;
    display: flex;
    .el-form-item__label {
      min-width: 75px;
      text-align: right;
    }
    .el-form-item__content {
      margin-right: 58px;
      width: 100%;
      flex: 1;
      .inputBox {
        display: flex;
        position: relative;
        &:hover {
          .clear-icon {
            display: block;
          }
        }
        .clear-icon {
          position: absolute;
          top: 8px;
          right: 0;
          font-size: 14px;
          color: #d8d8d8;
          cursor: pointer;
          display: none;
        }
        .el-input {
          width: auto;
          text-align: center;
        }
      }
    }
    .el-select {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
  }
}
.time-line-switch {
  position: absolute;
  top: 41px;
  right: 0;
  .p4 {
    padding: 8px;
    font-size: 12px;
    cursor: pointer;
    color: #5c5d5e;
    span {
      font-size: 14px;
      color: #c0c4cc;
      margin-left: 4px;
    }
  }
}
.resetting {
  top: 90px !important;
  right: 0 !important;
}
</style>
